import {
    AsyncValidatorFn,ValidatorFn
} from "@angular/forms";
import { NumericConfig } from "../models/config/numeric-config";
import { numericValidator  } from '../reactive-form-validators/index'
import { AnnotationTypes } from "../core/validator.static"
import { baseValidator, baseAsyncValidatorExtension } from "./base-validator.function";
import { baseAsyncValidator } from "../reactive-form-validators/async/base.async.validator";

export function numericValidatorExtension(config?: NumericConfig): ValidatorFn {
  return baseValidator(config, AnnotationTypes.numeric, numericValidator(config))
}
export function numericAsyncValidatorExtension(config?: NumericConfig): AsyncValidatorFn {
    return baseAsyncValidatorExtension(config, AnnotationTypes.numeric, baseAsyncValidator(config, AnnotationTypes.numeric));
}